"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapOrderDetailFeeToFee = void 0;
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var discount_types_1 = require("../../../types/discount.types");
var compute_tax_rate_1 = require("../../tax-rate/compute-tax-rate");
var types_1 = require("../../types");
var initialize_price_values_1 = require("../initialize-price-values");
var mapOrderDetailFeeToFee = function (fee) {
    var _a;
    var inclTax = new bignumber_js_1.default(fee.value);
    var exclTax = (0, compute_tax_rate_1.computeExclTaxFromInclTax)(inclTax, fee.taxRate);
    var tags = [types_1.ProductTag.Subventionnable];
    if (fee.applyScopeId) {
        tags.push(fee.applyScopeId);
    }
    return {
        label: fee.label ? fee.label : '',
        id: fee.id ? fee.id.toString() : '',
        discountableType: discount_types_1.DISCOUNTABLE_TYPE.FEE,
        totalPriceNotRounded: (0, initialize_price_values_1.initPricesNotRounded)(inclTax, exclTax),
        totalPriceRounded: (0, initialize_price_values_1.initPricesRounded)(),
        quantity: (_a = fee.quantity) !== null && _a !== void 0 ? _a : 1,
        taxRate: fee.taxRate,
        depth: 0,
        tags: tags,
        type: fee.type,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        additionalData: fee.additionalData,
        entranceFeeRawData: fee.entranceFeeRawData,
    };
};
exports.mapOrderDetailFeeToFee = mapOrderDetailFeeToFee;
